import { useCallback, useEffect, useRef } from "react"

import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer"

import { ZoomButtons } from "@l2r-front/l2r-map"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import * as Styled from "./PhotoSphereViewer.styled"

const ZOOM_STEP = 20
const DEFAULT_ZOOM = 50
const DEFAULT_YAW = Math.PI
const KEY_YAWS = {
    ArrowUp: 0,
    ArrowDown: DEFAULT_YAW,
}

export function PhotoSphereViewer(props) {

    const { imageUrl, onPositionChange, targetPosition } = props

    const photoSphereRef = useRef(null)
    const loadingRef = useRef(Promise.resolve())
    const isMobile = useIsMobileDevice()

    const handleZoomIn = useCallback(() => {
        if (photoSphereRef?.current) {
            const viewer = photoSphereRef.current
            const currentZoom = viewer.getZoomLevel()
            viewer.zoom(currentZoom + ZOOM_STEP)
        }
    }, [photoSphereRef])

    const handleZoomOut = useCallback(() => {
        if (photoSphereRef?.current) {
            const viewer = photoSphereRef.current
            const currentZoom = viewer.getZoomLevel()
            viewer.zoom(currentZoom - ZOOM_STEP)
        }
    }, [photoSphereRef])

    useEffect(() => {
        const handleKeyDown = (event) => {
            const yaw = KEY_YAWS[event.key]
            if (!event.shiftKey || yaw === undefined || event.target?.closest?.("input, textarea, select, [contenteditable='true']")) {
                return
            }
            const viewer = photoSphereRef.current
            if (viewer) {
                event.preventDefault()
                viewer.zoom(DEFAULT_ZOOM)
                viewer.rotate({ yaw, pitch: viewer.getPosition().pitch })
            }
        }
        window.addEventListener("keydown", handleKeyDown)
        return () => window.removeEventListener("keydown", handleKeyDown)
    }, [])

    useEffect(() => {
        if (imageUrl) {
            loadingRef.current = Promise.resolve(photoSphereRef?.current?.setPanorama(imageUrl)).catch(() => undefined)
        }
    }, [imageUrl])

    useEffect(() => {
        if (targetPosition) {
            loadingRef.current.then(() => {
                photoSphereRef.current?.rotate({ yaw: targetPosition.yaw, pitch: targetPosition.pitch ?? 0 })
            })
        }
    }, [targetPosition])

    return (
        <>
            <ReactPhotoSphereViewer
                height="100%"
                keyboard={false}
                navbar={false}
                onPositionChange={onPositionChange}
                ref={photoSphereRef}
                width="100%"
                defaultYaw={DEFAULT_YAW}
                defaultPitch={0}
                defaultZoomLvl={DEFAULT_ZOOM}
            />
            {!isMobile && <Styled.BottomRightAnchor>
                <ZoomButtons
                    onZoomIn={handleZoomIn}
                    onZoomOut={handleZoomOut}
                />
            </Styled.BottomRightAnchor>}
        </>
    )

}